"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var crypto = require("crypto");
var HASH_KEY = 'f5496681a8314a7273679919752ceb2e3afc3e6b';
var BRIDGE_MOBILE_URL = 'https://msearch.shopping.naver.com/bridge/searchGate.nhn';
exports.bridgeUrl = function (params) {
    if (!params)
        return;
    var nvMid = params.nvMid, frm = params.frm, catId = params.catId;
    if (!nvMid)
        return;
    var t = moment()
        .valueOf()
        .toString(36)
        .toUpperCase();
    var shaSum = crypto.createHash('sha1');
    shaSum.update("" + HASH_KEY + t);
    var h = shaSum.digest('hex');
    return BRIDGE_MOBILE_URL + "?frm=" + frm + "&cat_id=" + (catId || '') + "&nv_mid=" + nvMid + "&h=" + h + "&t=" + t;
};
//# sourceMappingURL=bridgeUrl.js.map